import { useEffect, useState } from 'react'

// Reactive window.matchMedia: returns true while the query matches.
export default function useMediaQuery(query) {
    const [matches, setMatches] = useState(() =>
        typeof window !== 'undefined' && window.matchMedia
            ? window.matchMedia(query).matches
            : false
    )

    useEffect(() => {
        const media = window.matchMedia(query)
        const onChange = () => setMatches(media.matches)

        onChange()
        media.addEventListener('change', onChange)

        return () => media.removeEventListener('change', onChange)
    }, [query])

    return matches
}
